import { FieldSettings } from '@progress/kendo-react-data-tools'
import { RateMarkupFilterKey } from 'api/Exchange-Rates/RateMarkupDto'
import { GridFilterOperatorEnum, GridFilterOperatorNameEnum } from 'types/GridFilterOperatorEnum'

import { SelectWalletCurrenciesFilter } from '../WalletFields/SelectWalletCurrenciesFilter'
import { SelectWalletTypeFilter } from '../WalletFields/SelectWalletTypeFilter'

export const getAdministrationRateMarkupsFields = (): FieldSettings[] => [
  {
    name: RateMarkupFilterKey.debitWalletType,
    label: 'Debit Wallet Type',
    filter: SelectWalletTypeFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
    ],
  },
  {
    name: RateMarkupFilterKey.debitCurrency,
    label: 'Debit Currency',
    filter: SelectWalletCurrenciesFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.likeOperator,
        operator: GridFilterOperatorEnum.likeOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notLikeOperator,
        operator: GridFilterOperatorEnum.notLikeOperator,
      },
    ],
  },
  {
    name: RateMarkupFilterKey.creditWalletType,
    label: 'Credit Wallet Type',
    filter: SelectWalletTypeFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
    ],
  },
  {
    name: RateMarkupFilterKey.creditCurrency,
    label: 'Credit Currency',
    filter: SelectWalletCurrenciesFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.likeOperator,
        operator: GridFilterOperatorEnum.likeOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notLikeOperator,
        operator: GridFilterOperatorEnum.notLikeOperator,
      },
    ],
  },
]
